import { render } from "./ChatTable.vue?vue&type=template&id=35353586&scoped=true"
import script from "./ChatTable.vue?vue&type=script&lang=js"
export * from "./ChatTable.vue?vue&type=script&lang=js"

import "./ChatTable.vue?vue&type=style&index=0&id=35353586&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35353586"]])

export default __exports__
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpace,QBtn,QTooltip});
